import React from 'react';

import { useHandleDebounce } from '@hooks';
import { IBasicTestProps } from '@styles/model';
import { ReactFCC } from '@types';

import { DEFAULT_BUTTON_DEBOUNCE_TIME } from './constants';
import { ETextDecoration } from './model';
import { TextButtonStyled } from './styled';

export interface ITextButton extends IBasicTestProps {
  contextHelpText?: string;
  onClickAction: () => void;
  textDecoration: ETextDecoration;
  hasHover?: boolean;
  disabled: boolean;
  withDebounce?: boolean;
  debounceTime?: number;
}

export const TextButton: ReactFCC<ITextButton> = ({
  contextHelpText,
  children,
  onClickAction,
  textDecoration,
  hasHover,
  disabled,
  withDebounce = false,
  debounceTime = DEFAULT_BUTTON_DEBOUNCE_TIME,
  ...rest
}) => {
  const debouncedHandle = useHandleDebounce(onClickAction, debounceTime);

  return (
    <TextButtonStyled
      onClick={withDebounce ? debouncedHandle : onClickAction}
      title={contextHelpText}
      textDecoration={textDecoration}
      hasHover={hasHover}
      disabled={disabled}
      {...rest}>
      {children}
    </TextButtonStyled>
  );
};
